import React from "react";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "../../Utils/responsive";
import "../../App.scss";
import OpenQuote from "../Risk/open-quote";
import CloseQuote from "../../Components/Risk/close-quote";
const { View, StyleSheet, Text, Dimensions } = require("react-native");

export const TriangleCorner = (props) => {
  return (
    <>
      <View style={styles.rectangle}>
        <View style={{ paddingVertical: 24 }}>
          <OpenQuote />
          <Text style={styles.triangleCornerText}>{props.test}</Text>
          <CloseQuote />
        </View>
      </View>
      <View style={[styles.triangleCorner]} />
    </>
  );
};

const styles = StyleSheet.create({
  triangleCorner: {
    marginLeft: wp("2%"),
    width: hp("0%"),
    height: hp("0%"),
    backgroundColor: "transparent",
    borderStyle: "solid",
    borderRightWidth:
      Dimensions.get("screen").width > 1200 ? wp("3%") : wp("7%"),
    borderTopWidth: Dimensions.get("screen").width > 1200 ? wp("3%") : wp("7%"),
    borderRightColor: "transparent",
    borderTopColor: "rgba(111, 213, 218, 0.15)",
    marginBottom: hp("2%"),
    transform: [{ rotate: "90deg" }],
  },
  rectangle: {
    marginLeft: wp("2%"),
    width:
      Dimensions.get("screen").width > 700
        ? Dimensions.get("screen").width > 1200
          ? wp("30%")
          : wp("70%")
        : wp("95%"),
    backgroundColor: "rgba(111, 213, 218, 0.15);",
  },

  triangleCornerText: {
    padding: hp("3.5%"),
    fontSize: Dimensions.get("screen").width > 1300 ? 24 : hp("3%"),
    fontWeight: "var(--font-weight-light)",
    color: "var(--text-color-default)",
    fontStyle: "normal",
    letterSpacing: 2.4,
  },
});
